import React from "react"
import { Button, componentStyles } from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket"

import WishlistButton from "~components/pages/wishlist/wishlist-button"
import ConditionalRenderContainer from "~components/shared/todo-lib-react-components/conditional-render-container"
import COPY from "~config/copy-constants"
import { useCopyOrShare } from "~utils/use-copy-or-share"

interface Props {
    readonly listingId: string
    readonly shouldHideButtons?: boolean
}

export default function ListingTitleActionButtons({
    listingId,
    shouldHideButtons,
}: Props) {
    const styles = useStyles()
    const copyOrShare = useCopyOrShare()

    return (
        <ConditionalRenderContainer
            style={styles.root}
            shouldRender={!shouldHideButtons}
        >
            <Button
                leftIcon={<FontAwesomeIcon icon={faArrowUpFromBracket} />}
                variant="link"
                onClick={copyOrShare}
                style={styles.button}
            >
                {COPY.SHARE.SHARE}
            </Button>
            <WishlistButton listingId={listingId} isInTitle />
        </ConditionalRenderContainer>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            display: { base: "none", md: "initial" },
        },
        button: {
            top: "5px",
        },
    })
}
